import React, {Component} from "react";
import {
    api,
    apis,
    db_tables,
    DBHelpers,
    msg,
    rd,
    route,
    routes,
    sendGet,
    throws,
    type_modal,
    type_modal_icon,
    type_popup,
    website,
    websites
} from "../../vars/rd";
import {connect} from "react-redux";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import DaoCategory from "../../modules/dao/category";
import DaoMain from "../../modules/dao/main";
import {modalShow} from "../../libs/redux/actions/modal";
import DaoUser from "../../modules/dao/user";
import {jsi} from "../../index";
import CategoryBusiness from "../components/buttons/category.business";
import {popupShow} from "../../libs/redux/actions/popup";
import {withRouter} from "react-router-dom";

/**
 * 헤더목록
 */
class Header extends Component {
    msg;
    constructor(props) {
        super(props);

        this.history = props.history;
        this.msg = msg();
        const [,, url2,] = window.location.hash.split("/");

        this.state = {
            open: false,
            openInfomation: false,
            bbsNew: (rd.main ? rd.main.bbsNew : 0),
            menu: (url2 || ''),
        }
    }

    // noinspection JSDeprecatedSymbols
    componentWillReceiveProps(nextProps) {
        // 사이드바 디스플레이 상태와 현재 상태를 비교해서 적용한다
        if(nextProps.sidebar.display !== this.state.open) {
             this.sidebarToggle(nextProps.sidebar.display);
        }
    }

    get dispatch() {
        return this.props.hasOwnProperty('dispatch') ? this.props.dispatch : () => {};
    }

    /**
     * Sidebar Toggle
     */
    sidebarToggle(open=undefined) {
        if(open === undefined) open = !this.state.open;
        this.setState({open});
    }

    /**
     *
     * @param menu
     */
    menuChange(menu) {
        if(menu === "search") {
            menu = this.history.location.pathname.includes('/broadcast') ? 'search_ment' : 'search_channel';
        }

        this.setState(
            {menu},
            async () => {
                if(!menu) await this.magazine();
                else {
                    if(routes.hasOwnProperty(menu)) route(routes[menu]);
                }
            }
        );
    }

    /**
     * @param e
     */
    profileError(e) {
        if (e) {
            e.target.onerror = null;
            e.target.src = "/images/avatar.png";
        }
    }

    mypage() {
        route(routes.mypage);
        this.sidebarToggle(false);
    }

    notice() {
        route(routes.notice, '0');
        this.sidebarToggle(false);
    }

    setting() {
        route(routes.setting);
        this.sidebarToggle(false);
    }

    event_logs() {
        route(routes.event_logs);
        this.sidebarToggle(false);
    }

    cscenter() {
        route(routes.cscenter);
        this.sidebarToggle(false);
    }

    searchBusiness() {
        if(rd.user.business)
            route(routes.search_business, rd.user.business);
    }

    get user() {
        return rd.user;
    }

    /**
     * 매거진
     * @returns {Promise<void>}
     */
    async magazine() {
        this.dispatch(preloaderShow());

        const url = api(apis.magazine, {
            groupid: rd.user.groupid,
            serviceid: rd.user.serviceid,
        });
        sendGet(url)
            .then(async json => {
                if (!json || json.result !== "OK") throws(json.message || this.msg.api_fail);
                if (json.status !== "OK") throws(json.message || this.msg.json_fail);

                // business
                if (json.hasOwnProperty('business')) {
                    rd.category.business = [];
                    (json.business || []).forEach(business => {
                        rd.category.business.push(new DaoCategory(business));
                    });
                }

                // genre
                if (json.hasOwnProperty('genre')) {
                    rd.category.genre = [];
                    (json.genre || []).forEach(genre => {
                        rd.category.genre.push(new DaoCategory(genre));
                    });
                }

                // tempo
                if (json.hasOwnProperty('tempo')) {
                    rd.category.tempo = [];
                    (json.tempo || []).forEach(tempo => {
                        rd.category.tempo.push(new DaoCategory(tempo));
                    });
                }

                // ment
                if (json.hasOwnProperty('cmCategory')) {
                    rd.category.ment = json.cmCategory;
                }

                // theme
                if (json.hasOwnProperty('theme')) {
                    rd.category.theme = [
                        new DaoCategory({
                            proid: 'all',
                            parid: null,
                            proname: "전체",
                            order: 1,
                            class: "all",
                            color: "#000000",
                            image: null
                        }),
                        new DaoCategory({
                            proid: 'best',
                            parid: null,
                            proname: "라임덕 BEST",
                            order: 2,
                            class: "best",
                            color: "#FFAB1C",
                            image: '/images/theme-best.png'
                        })
                    ];
                    (json.theme || []).forEach(theme => {
                        rd.category.theme.push(new DaoCategory(theme));
                    });
                }

                // shop
                if (json.hasOwnProperty('shop')) {
                    const shop = json.shop;
                    if (shop) {
                        rd.user.serviceid = shop.serviceid;

                        // business 가 prodid 아니고 code임
                        if (!!shop.business) {
                            (rd.category.business || []).forEach(
                                /** @param business {DaoCategory} */
                                business => {
                                    if (business.code === shop.business) {
                                        rd.user.business = business.proid;
                                    }
                                }
                            );
                        }
                        rd.user.bizid = shop.bizid;
                        rd.user.bizname = shop.bizname;
                        rd.user.end = shop.end;
                        rd.user.groupid = shop.groupid;
                        rd.user.id = shop.id;
                        rd.user.mac = shop.mac;
                        rd.user.shopid = shop.shopid;
                        rd.user.shopname = shop.shopname;
                        rd.user.profile_img = shop.profile_img;
                        rd.user.mobile = shop.mobile;
                        rd.user.zipcode = shop.zipcode;
                        rd.user.address = shop.address;
                        rd.user.address_detail = shop.address_detail;
                    }
                }
                rd.main = new DaoMain().setData(json);
                route(!rd.user.shopBusinessExists ? routes.business : routes.main);
            })
            .catch(async e => {
                this.dispatch(
                    modalShow(
                        type_modal.alert,
                        {
                            icon: type_modal_icon.error,
                            header: this.msg.magazine,
                            message: e.message
                        },
                        async () => await this.logout()
                    )
                );
            })
            .finally(() => {
                // 프리로더 제거
                this.dispatch(preloaderHide());
            });
    }

    logOut() {
        this.dispatch(
            modalShow(
                type_modal.confirm,
                {
                    icon: type_modal_icon.warn,
                    header: this.msg.logout,
                    message: this.msg.confirm_logout,
                    buttons: {
                        yes: this.msg.logout
                    }
                },
                async (rs) => {
                    if (rs) {
                        DBHelpers.openDB()
                            .then(async db => {
                                try {
                                    const users = await db.select(db_tables.users, () => true);
                                    if (users) {
                                        await db.updateBulk(db_tables.users, {...users, mac: null}, doc => {
                                            return doc.id === users.id
                                        });
                                    }
                                } catch (e) {
                                } finally {
                                    rd.user = new DaoUser();
                                    jsi.jsi_logout();
                                }
                            });
                    }
                }
            )
        );
    }

    openBrowser(url) {
        jsi.jsi_open_browser(url);
    }

    openInformationToggle() {
        this.setState({ openInfomation: !this.state.openInfomation });
    }

    shopBusinessEdit() {
        this.dispatch(popupShow(type_popup.business, this.user.shopBusiness));
    }

    render() {
        return (
            <div>
                {/* Header Menu */}
                <div className="header">
                    <div className="header-wrap">
                        <h2 className="logo">
                            <img src="/images/logo.png" alt={rd.name} className={'hand'}
                                 onClick={() => this.menuChange('')}/>
                        </h2>
                        <div className="nav">
                            <ul>
                                <li className={(this.state.menu === '' || this.state.menu === 'search_channel') ? 'on' : ''}
                                    onClick={() => this.menuChange('')}>채널
                                </li>
                                <li className={(this.state.menu === 'broadcast' || this.state.menu === 'search_ment') ? 'on' : ''}
                                    onClick={() => this.menuChange('broadcast')}>방송
                                </li>
                            </ul>
                        </div>
                        <div className="menu">
                            <span className="sch-wrap">
                                <img src="/images/icon-sch.png" alt={'검색'}
                                     onClick={() => this.menuChange('search')}/>
                            </span>
                            <div className="user-wrap">
                                <div className="user-box">
                                    <span className="user-name"
                                          onClick={(e) => this.mypage(e)}>{this.user.shopName}</span>
                                    <span className="user-type"
                                          onClick={() => this.searchBusiness()}>{this.user.shopBusinessName}</span>
                                </div>
                                <div className="user-image" onClick={(e) => this.mypage(e)}>
                                    <span><img src={this.user.shopImage} alt={this.user.shopName}
                                               onError={e => this.profileError(e)}/></span>
                                </div>
                            </div>
                            <div className="icon-menu">
                                <img src="/images/icon-menu.png" alt={'menu'} onClick={() => this.sidebarToggle()}/>
                            </div>
                        </div>
                    </div>
                </div>

                {/* SideBar */}

                <div className={`sidebar ${this.state.open ? "" : "hide"}`}>
                    <div className="menu-bg" onClick={() => this.sidebarToggle()}></div>
                    <div className="menu-box">
                        <div className="close-wrap" onClick={() => this.sidebarToggle()}>
                            <img src="/images/icon-close.png" alt="" />
                        </div>
                        <div className="top-user">
                            <div className="profile-image" onClick={(e) => this.mypage(e)}>
                                 <span><img src={this.user.shopImage} alt={this.user.shopName}
                                            onError={e => this.profileError(e)}/></span>
                            </div>
                            <div className="nick" onClick={(e) => this.mypage(e)}>{this.user.shopName}</div>
                            <div className="business_type"
                                 onClick={(e) => this.searchBusiness(e)}>{this.user.shopBusinessName}</div>
                        </div>
                        <div className="m-mypage">
                            <div className="mytype">
                                <h4>내 업종<span className="btn-modify" onClick={() => this.shopBusinessEdit()}><img src="/images/icon-modify.png" alt="내 업종"/></span></h4>
                                <div className="type-wrap">
                                    <CategoryBusiness category={this.user.shopBusiness} is_mypage={true} />
                                </div>
                            </div>
                            <div className="mytype">
                                <h4>이용권</h4>
                                <div className="type-wrap">
                                    <div className="item">
                                        <div className="name"><span>[{this.user.payment_type}]</span>{this.user.payment_name}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sidebar-menu">
                            <ul>
                                <li onClick={() => this.mypage()}>마이페이지</li>
                                <li className="mobile-only"><a className="m-myinfo" onClick={() => this.openInformationToggle()}>내 정보</a></li>
                                <li onClick={() => this.notice()}>공지사항<span className={`new ${this.state.bbsNew ? '' : 'hide'}`}>{this.state.bbsNew}</span></li>
                                <li onClick={() => this.setting()}>플레이어 설정</li>
                                <li onClick={() => this.event_logs()}>이벤트 로그</li>
                                <li onClick={() => this.cscenter()}>고객센터</li>
                            </ul>
                        </div>
                        <div className="mobile-customer mobile-only">
                            <h2>고객센터</h2>
                            <div className="item">
                                <div className="box">
                                    <h3>자주 묻는 질문</h3>
                                    <a onClick={()=> this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("faq")}))}><img src="/images/icon-myppage1.png" alt="" /></a>
                                </div>
                                <div className="box">
                                    <h3>1:1 문의</h3>
                                    <a onClick={()=> this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("inquiry")}))}><img src="/images/icon-myppage2.png" alt="" /></a>
                                </div>
                                <div className="box box2">
                                    <h3>상담원 연결</h3>
                                    <p>운영시간 : 평일 오전 9시 ~ 오후 6시</p>
                                    <a href={`tel:${(rd.main && rd.main.information) ? rd.main.information.customer_tel : ""}`}>
                                        <img src="/images/icon-myppage3.png" alt="고객센터 연결" />
                                    </a>
                                </div>
                            </div>
                            <span className="link-logout"><a onClick={() => this.logOut()}>로그아웃</a></span>
                        </div>
                    </div>
                </div>

                {/*모바일전용 내정보*/}
                <div className={`myinfo ${this.state.openInfomation ? 'active' : ''}`}>
                    <div className="menu-bg"></div>
                    <div className="mypage-cont">
                        <h2>
                            <span className="back-wrap" onClick={() => this.openInformationToggle()}><img src="/images/icon-back.png" alt="" /></span>내 정보
                            <div className="close-wrap" onClick={() => this.openInformationToggle()}><img src="/images/icon-close.png" alt="" /></div>
                        </h2>
                        <div className="mypage-info">
                            <dl>
                                <dt className="title">상호명</dt>
                                <dd className="text">{`${this.user.bizname} - ` || ''} {this.user.shopName}</dd>
                            </dl>
                            <dl>
                                <dt className="title">아이디</dt>
                                <dd className="text">{this.user.id}</dd>
                            </dl>
                            <dl>
                                <dt className="title">매장 주소</dt>
                                <dd className="text">{this.user.shopAddress}</dd>
                            </dl>
                            <dl>
                                <dt className="title">휴대전화번호</dt>
                                <dd className="text">{this.user.mobile}</dd>
                            </dl>
                        </div>
                        <div className="mypage-link-wrap">
                            상세한 정보 확인 및 수정은 홈페이지에서 가능합니다.
                            <span className="btn-link">
                                <a onClick={() => this.openBrowser(website(websites.destination, {query: rd.user.websiteParameters("mypage")}))}>홈페이지에서 보기 <img src="/images/icon-link.png" alt="" /></a>
                            </span>
                        </div>
                    </div>
                </div>
                {/*모바일전용 내정보*/}
            </div>
        );
    }
}

const userStateToProps = (state) => ({
    user: state.user,
    sidebar: state.sidebar,
});

export default connect(userStateToProps)(withRouter(Header));


// WEBPACK FOOTER //
// ./src/pages/include/header.jsx